// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// ↓ ajouter "export" ici
export const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
export const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseKey) {
  console.error('[supabaseClient] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_ANON_KEY.');
  console.error('[supabaseClient] REACT_APP_SUPABASE_URL=', supabaseUrl);
  console.error('[supabaseClient] REACT_APP_SUPABASE_ANON_KEY=', supabaseKey ? '***present***' : supabaseKey);
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  global: {
    headers: {
      apikey: supabaseKey || ''
    }
  }
});